import { render } from "./TrainingTools.vue?vue&type=template&id=630dfa65&scoped=true"
import script from "./TrainingTools.vue?vue&type=script&lang=js"
export * from "./TrainingTools.vue?vue&type=script&lang=js"

import "./TrainingTools.vue?vue&type=style&index=0&id=630dfa65&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630dfa65"]])

export default __exports__